import { render } from "./FormulaContent.vue?vue&type=template&id=cf0ca630&scoped=true&ts=true"
import script from "./FormulaContent.vue?vue&type=script&lang=ts"
export * from "./FormulaContent.vue?vue&type=script&lang=ts"

import "./FormulaContent.vue?vue&type=style&index=0&id=cf0ca630&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf0ca630"]])

export default __exports__